import React from 'react';
import '../App.css'
import {useEffect, useState, useRef} from 'react'
import { InView } from "react-intersection-observer";
//
import SpecialLineSvg from '../svg/home/SpecialLineSvg'
import LtoRLine from '../svg/special/LToRLine.js'
import RToLLine from '../svg/special/RToLLine.js'
import RToLLine2 from '../svg/special/RToLLine2.js'
import InViewComponent from './InViewComponent.js';
import { use } from 'react';
const CONTENT = {
    0:{
        title:'一站式安居服務',
        a:'精選優質安居服務推薦',
        b:'全程協助',
        c:'採購指導',
    },
    1:{
        title:'專業社交圈',
        a:'銀行開戶指引',
        b:'通訊服務辦理',
        c:'醫療保險諮詢',
    },
    2:{
        title:'生活便利支援',
        a:'高端人脈交流活動',
        b:'行業分享會',
        c:'專業交流聚會',
    },
    3:{
        title:'一站式安居服務',
        a:'香港地道美食推薦',
        b:'週末休閒活動',
        c:'文化體驗活動',
    },
}
const About = ({isSpecial, speicalIdx, isFlipped = false}) => {
    const [idx, setIdx] = useState(0)
    const [isEnter, setIsEnter] = useState(false)
    const ref1 = useRef(null)
    const ref2 = useRef(null)
    const ref3 = useRef(null)
    const ref4 = useRef(null)
    const refArr = [ref1, ref2, ref3, ref4]
    const refAppear = useRef(null)
    const refAppear1 = useRef(null)
    const reftext1 = useRef(null)
    const reftext2 = useRef(null)
    const refbullet1 = useRef(null)
    const refbullet2 = useRef(null)
    const refbullet3 = useRef(null)
    const refbullet4 = useRef(null)
    const refbullet5 = useRef(null)
    const refbullet6 = useRef(null)
    useEffect(() => {
        if(!isEnter) return;
        const timer = setTimeout(() => {
            setIdx(prev => (prev + 1) % 4)
        }, 5000)
        return () => {
            clearTimeout(timer)
        }
    }, [isEnter,idx])

    if(isSpecial){
        if(!isFlipped){
            return (
            <div className='select-none flex flex-row-col items-start justify-center w-full relative pt-[40px]' style={{zIndex:1}}>
                <InView as="div" className='absolute top-[-1%]' onChange={(inView, entry) => {if(inView){setIsEnter(true);}}}>
                </InView>
                <div className='flex flex-col items-center justify-center relative' style={{flex:1.3}}>
                    <div className='w-full overflow-hidden flex flex-row justify-center min-w-[50vw] d-w-25vw-m-60vw' style={{aspectRatio:16/9, alignItems: [3].includes(idx) ? 'flex-start' : 'center'}}>
                        <img className='w-full' style={{aspectRatio:1, height:undefined}} src={`../img/caro/sec2/${speicalIdx}.png`}></img>
                    </div>
                    <div className='d-w-25vw-m-60vw h-full border border-[2px] absolute top-[-4%] left-[-4%]'>
                    </div>
                </div>
                <div className='h-full overflow-x-show w-[50px] relative d-block-m-hidden' style={{flex:0,zIndex:98}}>
                    <SpecialLineSvg width={'15vw'} newid={'sdfsdfasd'}/>
                </div>
                <div className='w-full h-full d-hidden-m-show' style={{zIndex:9}}>
                    <LtoRLine width={'30%'}/>
                </div>
                <div className='flex flex-col items-center justify-center h-full w-full relative' style={{flex:1}}>
                    <div className='w-full h-full flex flex-col items-center justify-center'>
                        <div className='w-full h-full flex flex-col items-center justify-center d-mt-150-m-0'>
                            <div ref={refAppear} className='appear_bottom_to_top w-full flex flex-row items-center justify-center pb-[54px] relative'>
                                <div className='w-full h-full absolute flex flex-row items-start justify-center' style={{zIndex:0}}>
                                    <img src='../img/home/g_square.png' className='w-[30%] ml-[50%] mt-[-15%]' style={{aspectRatio:1/1, height:undefined}}></img>
                                </div>
                                <div className='bg-white overflow-hidden relative flex flex-row justify-center d-w-25vw-m-90vw' key={speicalIdx} style={{aspectRatio:16/9, height:undefined, zIndex:1, alignItems: [1].includes(speicalIdx) ? 'flex-start' : 'center'}}>
                                    <img className='w-full min-w-[150px]' key={speicalIdx} style={{aspectRatio:(350/374), zIndex:1}} src={`../img/caro/sec2/${speicalIdx}_.png`}></img>
                                </div>                           
                            </div>
                            <InViewComponent reffing={refAppear} active={'appear_bottom_to_top_active'}/>
                            <div className='w-full px-[10%] border-t border-l border-b flex flex-row items-center justify-start py-[22px] abs-right d-w-full-m-40per'>
                                <div className='flex flex-col items-center justify-center'>
                                    <div ref={reftext1} className='div_left_right_container_white_9c866a text-white pb-[22px] font-bold text-[25px]'>{CONTENT[speicalIdx].title}</div>
                                    <InViewComponent reffing={reftext1} active={'div_left_right_container_is-active'}/>
                                    <div className='border-t pt-[22px]'>
                                        <ul className='list-disc flex flex-row-col d-gap-12-m-4 text-white text-start'>
                                            <li ref={refbullet1} className='appear_bottom_to_top'>{CONTENT[speicalIdx].a}</li>
                                            <li ref={refbullet2} className='appear_bottom_to_top'>{CONTENT[speicalIdx].b}</li>
                                            <li ref={refbullet3} className='appear_bottom_to_top'>{CONTENT[speicalIdx].c}</li>
                                        </ul>
                                    </div>
                                    <InViewComponent isSpecial={() => {
                                        setTimeout(() => {refbullet1.current.classList.add('appear_bottom_to_top_active')},0)
                                        setTimeout(() => {refbullet2.current.classList.add('appear_bottom_to_top_active')},300)
                                        setTimeout(() => {refbullet3.current.classList.add('appear_bottom_to_top_active')},600)
                                    }}/>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )
        }else{
            return (
                <div className='select-none flex flex-row-col items-start justify-center w-full relative pt-[40px] m-flex-reverse' style={{zIndex:1}}>
                    <InView as="div" className='absolute top-[-1%]' onChange={(inView, entry) => {if(inView){setIsEnter(true);}}}>
                    </InView>
                    <div className='flex flex-col items-center justify-center h-full w-full relative' style={{flex:1}}>
                        <div className='w-full h-full flex flex-col items-center justify-center'>
                            <div className='w-full h-full flex flex-col items-center justify-center d-mt-150-m-0'>
                                <div ref={refAppear1} className='appear_bottom_to_top w-full flex flex-row items-center justify-center pb-[54px] relative ml-[2.3vw]'>
                                    <div className='w-full h-full absolute flex flex-row items-start justify-center' style={{zIndex:0}}>
                                        <img src='../img/home/g_square.png' className='w-[30%] ml-[-50%] mt-[-15%]' style={{aspectRatio:1/1, height:undefined}}></img>
                                    </div>
                                    <div className='bg-white overflow-hidden relative flex flex-row justify-center d-w-25vw-m-90vw' key={speicalIdx} style={{aspectRatio:16/9, height:undefined, zIndex:1, alignItems: [0,1].includes(speicalIdx) ? 'flex-start' : 'center'}}>
                                        <img className='w-full min-w-[150px]' key={speicalIdx} style={{aspectRatio:(350/374), zIndex:1}} src={`../img/caro/sec2/${speicalIdx}_.png`}></img>
                                    </div>
                                </div>
                                <InViewComponent reffing={refAppear1} active={'appear_bottom_to_top_active'}/>
                                <div className='w-full px-[10%] border-t border-r border-b border-[#744F1B] flex flex-row items-center justify-end py-[22px] abs-start d-w-full-m-40per'>
                                    <div className='flex flex-col items-center justify-center'>
                                        <div ref={reftext2} className='div_left_right_container_744F1B_dfd8d0 text-[#744F1B] pb-[22px] font-bold text-[25px]'>{CONTENT[speicalIdx].title}</div>
                                        <InViewComponent reffing={reftext2} active={'div_left_right_container_is-active'}/>
                                        <div className='border-t pt-[22px]'>
                                            <ul className='list-disc flex flex-row-col d-gap-12-m-4 text-[#744F1B] text-start'>
                                                <li ref={refbullet4} className='appear_bottom_to_top'>{CONTENT[speicalIdx].a}</li>
                                                <li ref={refbullet5} className='appear_bottom_to_top'>{CONTENT[speicalIdx].b}</li>
                                                <li ref={refbullet6} className='appear_bottom_to_top'>{CONTENT[speicalIdx].c}</li>
                                            </ul>
                                        </div>
                                        <InViewComponent isSpecial={() => {
                                            setTimeout(() => {refbullet4.current.classList.add('appear_bottom_to_top_active')},0)
                                            setTimeout(() => {refbullet5.current.classList.add('appear_bottom_to_top_active')},300)
                                            setTimeout(() => {refbullet6.current.classList.add('appear_bottom_to_top_active')},600)
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='h-full overflow-x-show w-[50px] relative d-block-m-hidden' style={{flex:0,zIndex:98}}>
                        <RToLLine width={'15vw'} newid={'sdfsdfasdasdfs'} className='absolute left-[-11.1vw]'/>
                        <div className='w-[50px]'></div>
                    </div>
                    <div className='w-full h-full d-hidden-m-show flex flex-row justify-end' style={{zIndex:9}}>
                        <RToLLine2 width={'30%'}/>
                    </div>
                    <div className='flex flex-row items-center justify-center relative ml-auto' style={{flex:1.3}}>
                        <div className='w-full overflow-hidden flex flex-row justify-center min-w-[50vw] d-w-25vw-m-60vw' style={{aspectRatio:16/9, alignItems: [3].includes(speicalIdx) ? 'flex-start' : 'center'}}>
                            <img className='w-full' style={{aspectRatio:1, height:undefined}} src={`../img/caro/sec2/${speicalIdx}.png`}></img>
                        </div>
                        <div className='d-w-25vw-m-60vw h-full border border-[2px] border-[#BEA56C] absolute top-[-4%] left-[4%]'>
                        </div>
                    </div>
                </div>
                )            
        }
    }

    return (
        <div className='select-none flex flex-row-col items-start justify-center w-full min-h-[600px] mt-[50px] h-[60vh] max-h-[100vh] relative mb-[50px]' style={{zIndex:1}}>
            <InView as="div" className='absolute top-[-1%]' onChange={(inView, entry) => {if(inView){setIsEnter(true); }}}>
            </InView>
            <div className='flex flex-row items-start justify-center'>
                <div className='bg-[#00000080] flex flex-col items-center justify-center relative d-show-m-hidden w-full max-w-[50vw]' style={{flex:1, height:undefined, aspectRatio:16/9}}>
                    <div className='w-full overflow-hidden flex flex-row justify-center min-w-[50vw]' style={{aspectRatio:16/9, alignItems: [3].includes(idx) ? 'flex-start' : 'center'}}>
                        {/* {isEnter && <div key={idx} className='w-full h-full scale-img' style={{backgroundImage: `url(./img/caro/sec2/${idx}.png)`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}>
                        </div>} */}
                        {isEnter && <img className='w-full scale-img' key={idx} style={{aspectRatio:1, height:undefined}} src={`./img/caro/sec2/${idx}.png`}></img>}
                    </div>
                    <div className='w-full h-full border border-[2px] absolute top-[-40px] left-[-40px]'>
                    </div>
                </div>
            </div>
            <div className='h-full overflow-x-show w-[50px] overflow-show relative w-[0px] d-block-m-hidden' style={{flex:0,zIndex:98}}>
                <SpecialLineSvg width={'11vw'} />
            </div>
            <div className='flex flex-col items-center justify-center w-full mt-[5%]' style={{flex:0.85}}>
                <div className='w-full h-full flex flex-col items-center justify-center'>
                    <div className='w-full h-full flex flex-col items-center justify-center'>
                        <div className='w-full flex flex-row items-center justify-center pb-[54px] relative'>
                            <div className='w-full h-full absolute flex flex-row items-start justify-center' style={{zIndex:0}}>
                                <img src='./img/home/g_square.png' className='w-[10vw] ml-[50%] mt-[-5%] min-w-[150px] d-show-m-hidden' style={{aspectRatio:1/1, height:undefined}}></img>
                            </div>
                            <div className='w-full h-full absolute flex flex-row items-start justify-end d-hidden-m-show' style={{zIndex:0}}>
                                <img src='./img/home/g_square.png' className='w-[10vw] ml-[50%] mt-[-5%] min-w-[150px]' style={{aspectRatio:1/1, height:undefined}}></img>
                            </div>
                            <div className='bg-white overflow-hidden relative flex flex-row justify-center d-w-25vw-m-90vw' style={{aspectRatio:16/9, height:undefined, zIndex:1, alignItems: [1].includes(idx) ? 'flex-start' : 'center'}}>
                                <img className='w-full min-w-[150px] appear_opacity_05' key={idx} style={{aspectRatio:(350/374), zIndex:1}} src={`./img/caro/sec2/${idx}_.png`}></img>
                            </div>
                        </div>
                        <div className='w-full px-[10%] flex flex-row items-center justify-center'>
                            <div className='max-w-[796px] w-full flex flex-row flex-wrap items-between justify-between pb-[14px]' style={{gap:14}}>
                                {['一站式安居服務','專業社交圈','生活便利支援','精選禮遇服務'].map((text,i) => <div onClick={() => setIdx(i)} ref={refArr[i]} className='appear_bottom_to_top select-none cursor-pointer border relative flex flex-row items-center justify-center font-bold transition-all sec3-4btn' style={{flex:1, color: (idx === i ? '#B69F6B' : '#fff'), backgroundColor: (idx === i ? '#fff' : 'transparent')}}>
                                    {idx === i && <div key={idx} className='line-grow h-[4px] absolute top-[-1px] left-[-1px]'></div>}
                                    {text}
                                </div>)}
                            </div>
                        </div>
                        <InViewComponent isSpecial = {() => {
                            setTimeout(() => {ref1.current.classList.add('appear_bottom_to_top_active')},0)
                            setTimeout(() => {ref2.current.classList.add('appear_bottom_to_top_active')},100)
                            setTimeout(() => {ref3.current.classList.add('appear_bottom_to_top_active')},230)
                            setTimeout(() => {ref4.current.classList.add('appear_bottom_to_top_active')},360)
                        }}/>
                    </div>

                
                </div>
            </div>
        </div>
    );
};

export default About;